import { MARQUEE } from "@/lib/data";

export function Marquee() {
  const row = [...MARQUEE, ...MARQUEE];
  return (
    <div className="overflow-hidden border-y border-line bg-ink-2 py-4 text-brass">
      <div className="marquee-track flex w-max gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={`${item}-${i}`} className="font-display flex items-center gap-10 text-2xl tracking-[0.12em] md:text-4xl">
            {item}
            <span className="inline-block h-1.5 w-1.5 rotate-45 bg-brass" />
          </span>
        ))}
      </div>
    </div>
  );
}
